<template>
  <v-hover v-slot="{hover}">
    <div class="d-flex align-center parent py-1" :class="`justify-${justifyAlign}`">
      <div class="buttons-container">
        <v-expand-transition>
          <m-btn
            v-if="hideCopy && hover"
            elevation="0"
            class="copy-text copy-btn color-white px-2"
            :class="{'is-hover': hover, 'copy-btn--half-width': showClientHistory && !isLeads}"
            @click.stop="onCopyClick">
            <v-icon class="fa-light fa-copy pr-1" /> {{ label || $t('common.copy') }}
          </m-btn>
        </v-expand-transition>
        <v-expand-transition>
          <m-btn
            v-if="hideCopy && hover && showClientHistory"
            elevation="0"
            class="copy-text copy-btn color-white px-2"
            :class="{'is-hover': hover, 'copy-btn--half-width': showClientHistory && !isLeads}"
            @click.stop="handleHistoryClick">
            <v-icon class="fa-light fa-user pr-1" /> {{ label || $t('buttons.history') }}
          </m-btn>
        </v-expand-transition>
      </div>
      <div :class="{'hover-opacity': hover}">
        <slot></slot>
      </div>
    </div>
  </v-hover>
</template>

<script lang="ts">
import {computed, defineComponent, PropType} from '@vue/composition-api'

enum LayoutAlign {
  center = 'center',
  end = 'end',
  start = 'start',
}
export default defineComponent({
  name: 'MCopy',
  props: {
    hideCopy: {
      type: Boolean,
      default: true,
    },
    showClientHistory: {
      type: Boolean,
      default: false,
    },
    origin: {
      type: String,
      required: false,
    },
    textToCopy: {
      type: String,
      required: true,
    },
    label: String,
    align: {
      type: String as PropType<LayoutAlign>,
      default: LayoutAlign.start,
    },
  },
  setup(props, {root, emit}) {
    function onCopyClick() {
      navigator.clipboard.writeText(props.textToCopy).then(() => {
        emit('onCopy')
      })
    }

    function handleHistoryClick() {
      emit('onHistoryClick')
    }

    const isLeads = computed(() => {
      return props.origin === '/leads'
    })

    const justifyAlign = computed(() => {
      return Object.values(LayoutAlign).includes(props.align) ? props.align : LayoutAlign.start
    })

    return {
      justifyAlign,
      isLeads,
      onCopyClick,
      handleHistoryClick,
      emit,
    }
  },
})
</script>

<style lang="scss" scoped>
.copy-text {
  cursor: pointer;
  margin-left: 10px;

  i {
    font-size: 16px !important;
  }
}
.parent {
  position: relative !important;

  // Extend hover zone to the left to cover the buttons
  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: -200px;
    width: 200px;
  }
}
.buttons-container {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  position: absolute;
}
.hover-opacity {
  opacity: 0.3;
}
.hover-opacity-bg {
  background: rgba(0, 0, 0, 0.1);
}
.copy-btn {
  z-index: 1;
  width: 100%;
  height: 100%;
  margin: 0;
  visibility: hidden;
  opacity: 0.75;
  background: #868686 !important;
  border-radius: 4px;
  max-width: 160px;

  &.is-hover {
    display: block;
    visibility: visible;
  }

  &--half-width {
    width: 50%;
  }

  &:hover {
    opacity: 1;
  }
}
</style>
